import { Injectable } from '@angular/core';
import { IVersion } from 'src/interfaces/version.interface';
import { VersionModel } from 'src/models/version.model';
import { ConnectionService } from '../connection/connection.service';

@Injectable({
  providedIn: 'root',
})
export class VersionRepository {
  constructor(private conn: ConnectionService) {}

  public async getVersion(): Promise<VersionModel> {
    const res = await this.conn.get(`assets/files/version.json`);
    return VersionModel.fromJson(res as IVersion);
  }
}
